import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import { buildStockIssueLineColumns } from '#/modules/imsMgmt/receipts/stockIssue/columns/stockIssueLineColumns';

const StockIssueLinesTable = ({ lines = [], status }) => {
  const showCompletedFields = status === 'COMPLETED';
  const columns = useMemo(
    () => buildStockIssueLineColumns({ showCompletedFields }),
    [showCompletedFields],
  );

  const rows = useMemo(
    () => (lines ?? []).map((line, index) => ({
      ...line,
      id: line.invStock?.id
        ? `${line.invStock.id}-${index}`
        : `line-${index}`,
    })),
    [lines],
  );

  const detailTableState = useDetailTable(rows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
    </div>
  );
};

StockIssueLinesTable.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
  status: PropTypes.string,
};

export default StockIssueLinesTable;
